import { css } from '@emotion/react';
import { LayoutMode_Enum } from '@weave/schema-gen-ts/dist/schemas/phone/devices/v2/devices.pb';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button, Text } from '@frontend/design-system';
import { DEVICE_LAYOUT_WIDTH } from '../constants';

export const TouchScreenModeToggle = ({
  touchScreenMode,
  onToggleMode,
}: {
  touchScreenMode: LayoutMode_Enum;
  onToggleMode: () => void;
}) => {
  const { t } = useTranslation('phone', { keyPrefix: 'line-keys' });

  return (
    <div
      id='device-model-pagination'
      css={css`
        max-width: ${DEVICE_LAYOUT_WIDTH};
        width: 100%;
        margin-top: ${theme.spacing(1)};
        display: flex;
        justify-content: center;
        flex-direction: column;
        gap: ${theme.spacing(1)};
      `}
    >
      <Button
        iconName={touchScreenMode === LayoutMode_Enum.COLLAPSED ? 'expand' : 'x'}
        onClick={onToggleMode}
        variant='tertiary'
      >
        {touchScreenMode === LayoutMode_Enum.COLLAPSED ? t('Expand') : t('Collapse')}
      </Button>
      <Text textAlign='center' color='subdued' size='medium'>
        {touchScreenMode === LayoutMode_Enum.EXPANDED
          ? t('Return to your phone’s main line keys grid')
          : t('Show your phone’s full line keys grid')}
      </Text>
    </div>
  );
};
